<script lang="ts">
  import CartWidgetGroupV2 from "@retailer/svelte/CartWidget/v2/CartWidgetGroupV2.svelte";
  import RequestItem from "@retailer/svelte/CartWidget/v2/middleware/RequestItem.svelte";
  import { InventoryItemStore } from "@retailer/svelte/CartWidget/v2/Stores/InventoryItemStore";
  import RetailerFulfillmentMethodsStore from "@retailer/svelte/stores/RetailerFulfillmentMethodsStore";
  import { onMount } from "svelte";
  import { CartWidgetTargetObjectBase } from "@shared/services/event_tracking/entities";
  import {
    sendCartTrackingEvents,
    sendClickTracking,
  } from "@retailer/svelte/CartWidget/v2/Services/CartEventTracking";
  import type { Notice } from "@retailer/svelte/CartWidget/v2/Services/CartItemRequestService";
  import type { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";
  import CartWidgetNotice from "@retailer/svelte/CartWidget/v2/CartWidgetNotice.svelte";
  import { isOHLQOrder } from "@retailer/services/order_fulfillment_service";

  export let inventoryId: number;
  export let orderFulfillmentWarehouse: { id: number | null; name: string | null } = null;
  export let orderFulfillmentWarehouseLocationCode: string | null = null;
  export let trackingEntities: BaseEntityClass[] = [];

  const targetObjectTypeBase = CartWidgetTargetObjectBase.OrderHistoryReorder;

  const trackCartChangeEvent = event => {
    sendCartTrackingEvents(event, trackingEntities, inventoryId);
  };

  const trackCartInteractionEvent = event => {
    sendClickTracking(targetObjectTypeBase, event, trackingEntities);
  };

  let loaded: boolean = false;

  onMount(async () => {
    loaded = false;
    const response = await InventoryItemStore.fetchInventoryItem(
      inventoryId,
      orderFulfillmentWarehouseLocationCode,
    );
    loaded = response?.loaded;
  });

  $: cartWidgetItem = $InventoryItemStore?.inventoryItems[inventoryId];
  $: informationalNotices = cartWidgetItem?.notices.filter((notice: Notice) => {
    return notice.level === "info" && notice.message;
  });
  $: notices = cartWidgetItem?.notices?.filter(notice => notice.level !== "info");
  $: fulfillmentMethod =
    $RetailerFulfillmentMethodsStore[cartWidgetItem?.distributor_summary?.id] || null;
  $: fulfillmentWarehouseId = isOHLQOrder(cartWidgetItem?.distributor_summary?.id)
    ? fulfillmentMethod?.warehouse_id
    : orderFulfillmentWarehouse?.id || cartWidgetItem?.distributor_summary?.default_warehouse_id;
</script>

<style>
  .container-div {
    display: flex;
    flex-direction: column;
  }
</style>

{#if loaded && cartWidgetItem}
  <RequestItem {cartWidgetItem} {fulfillmentWarehouseId}>
    <div class="container-div" slot="cart-widget">
      {#each notices as notice}
        <CartWidgetNotice {notice} />
      {/each}
      <CartWidgetGroupV2
        widgetItem={cartWidgetItem}
        {fulfillmentMethod}
        {fulfillmentWarehouseId}
        {orderFulfillmentWarehouse}
        showFulfillmentIndicator={true}
        on:cartWidgetChange={trackCartChangeEvent}
        on:updateQuantity={trackCartInteractionEvent}
      />
      {#each informationalNotices as notice}
        <CartWidgetNotice {notice} />
      {/each}
    </div>
  </RequestItem>
{/if}
